"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditorialCarouselSection = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _clsx = _interopRequireDefault(require("clsx"));
var _constants = require("./constants");
var _editorialCarouselSectionClasses = require("./editorialCarouselSectionClasses");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const EditorialCarouselSection = ({
  title,
  data,
  labelRead,
  id,
  button,
  className
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    relativeUrl,
    title: buttonTitle
  } = button ?? {};
  const shouldDisplayButton = !!relativeUrl && !!buttonTitle;
  const rootClassName = (0, _clsx.default)(_editorialCarouselSectionClasses.editorialCarouselSectionClasses.root, className);
  if (data.length === 0) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(_constants.EDITORIAL_CAROUSEL_SECTION),
    className: rootClassName,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Inner, {
      className: _editorialCarouselSectionClasses.editorialCarouselSectionClasses.inner,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        variant: "h4",
        component: "h2",
        align: "center",
        color: "textPrimary",
        className: _editorialCarouselSectionClasses.editorialCarouselSectionClasses.title,
        children: title
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CarouselContainer, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.EditorialCarousel, {
          data: data,
          labelRead: labelRead,
          labelWatch: "",
          id: id,
          className: _editorialCarouselSectionClasses.editorialCarouselSectionClasses.carousel
        })
      })]
    }), shouldDisplayButton ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledButton, {
      "data-testid": getTestId(_constants.EDITORIAL_CAROUSEL_SECTION_BUTTON),
      color: "default",
      variant: "outlined",
      href: relativeUrl,
      "aria-label": buttonTitle,
      className: _editorialCarouselSectionClasses.editorialCarouselSectionClasses.button,
      children: buttonTitle
    }) : null]
  });
};
exports.EditorialCarouselSection = EditorialCarouselSection;
